import { render, staticRenderFns } from "./CustomerSitesList.vue?vue&type=template&id=28f1b8c4&scoped=true&"
import script from "./CustomerSitesList.vue?vue&type=script&lang=js&"
export * from "./CustomerSitesList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSitesList.vue?vue&type=style&index=0&id=28f1b8c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f1b8c4",
  null
  
)

export default component.exports